import { Typography } from "@mui/material";
import { Variant } from "@mui/material/styles/createTypography";
import React, { ForwardedRef } from "react";
import { forwardRef } from "react";

interface IHeading {
  type?: Variant;
  text?: string;
  classes?: string;
  title?: string;
  font?: string;
  color?: string;
  fontWeight?: number;
  isBold?: boolean;
  style?: React.CSSProperties | undefined;
  onClick?: () => void;
}
const Heading = React.forwardRef(function (
  {
    type = "body1",
    text = "",
    classes = "",
    font = "",
    color = "",
    title = "",
    fontWeight,
    isBold = false,
    style = undefined,
    onClick,
  }: IHeading,
  ref: any
) {
  const attributes = font ? { fontSize: font } : "";
  return (
    <Typography
      ref={ref}
      color={color}
      className={classes}
      variant={type}
      title={title}
      fontWeight={fontWeight}
      onClick={onClick}
      style={style}
      {...attributes}
      sx={onClick ? { cursor: "pointer" } : undefined}
    >
      {isBold ? <b>{text}</b> : text}
    </Typography>
  );
});

export default Heading;
